import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Exam, ExamMLResultData, Note } from "types/Exam";

export interface ExamState {
  currentExam: Exam;
  isRemoveModalVisible: boolean;
  isDetailsModalVisible: boolean;
  loading: boolean;
  // minMaxFrames?: MinMaxFrames; //TODO: Remove it when is working withe the new ExamMLResult store
  examFrames: ExamMLResultData[];
}

const initialState: ExamState = {
  currentExam: {} as Exam,
  isRemoveModalVisible: false,
  isDetailsModalVisible: false,
  loading: false,
  // minMaxFrames: {} as MinMaxFrames,//TODO: Remove it when is working withe the new ExamMLResult store
  examFrames: [],
};

export const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setCurrentExam: (state, { payload }: PayloadAction<Exam>) => {
      state.currentExam = payload;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setRemoveModalVisibility: (state, { payload }: PayloadAction<boolean>) => {
      state.isRemoveModalVisible = payload;
    },
    setDetailsModalVisibility: (state, { payload }: PayloadAction<boolean>) => {
      state.isDetailsModalVisible = payload;
    },
    setNotes: (state, { payload }: PayloadAction<Note[]>) => {
      state.currentExam.notes = payload;
    },
    // setMinMaxFrames: (state, action: PayloadAction<MinMaxFrames>) => {//TODO: Remove it when is working withe the new ExamMLResult store
    //   state.minMaxFrames = action.payload;
    // },
    setExamFrames: (state, action: PayloadAction<ExamMLResultData[]>) => {
      state.examFrames = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCurrentExam,
  // setMinMaxFrames,//TODO: Remove it when is working withe the new ExamMLResult store
  setLoading,
  setRemoveModalVisibility,
  setDetailsModalVisibility,
  setNotes,
  setExamFrames,
} = examSlice.actions;
export const { reducer } = examSlice;
